export const days = [
    {
        "dayEn": "Sat",
        "dayEs": "Sáb"
    },
    {
        "dayEn": "Sun",
        "dayEs": "Dom"
    },
    {
        "dayEn": "Mon",
        "dayEs": "Lun"
    },
    {
        "dayEn": "Tue",
        "dayEs": "Mar"
    },
    {
        "dayEn": "Wed",
        "dayEs": "Mié"
    },
    {
        "dayEn": "Thu",
        "dayEs": "Jue"
    },
    {
        "dayEn": "Fri",
        "dayEs": "Vie"
    }
];